module.exports = __webpack_public_path__ + "images/modern-1-3001a1b3036051c4d5741c5bffc97736.jpg";